import { Formik, useField, Form } from 'formik'
import React, { useContext, useRef, useLayoutEffect } from 'react'
import AppNavigation from '../../AppNavigation'
import { AppContext } from '../../../App'
import axios from 'axios'
import * as Yup from 'yup'
import config from '../../../config.json'

export default function GroutCoverageDetails() {
   const {
      setAppHeader,
      setCurrentStep,
      stepsCompleted,
      setStepsCompleted,
      setCoverageDetails,
      productCoverage,
      tileThicknesses,
      jointSizes,
      unit,
      setUnit,
      setCoverageData,
      coverageData
   } = useContext(AppContext)
   
   //Create custom form elements
   const CustomInputTotalArea = ({ label, ...props }) => {
      const [field, meta] = useField(props)
      return (
         <div className="row form-group p-1">
               <div className="col-xs-12 col-sm-8">
                  <div className="row p-1">
                     <div className="col-xs-12 col-sm-6">
                           <label htmlFor={props.id || props.name}>{label}</label>
                     </div>
                     <div className="col-xs-12 col-sm-6">
                           <input className="text-input" {...field} {...props} />
                           { meta.touched && meta.error ? (
                              <div className="error">{ meta.error }</div>
                           ) : null }
                     </div>
                  </div>
               </div>
               <div className="col-xs-12 col-sm-4">
                  <label className="unit-label">
                     ft&#178;
                     <input type="radio" name="radio-unit" checked={unit==="sqft"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqft" value="sqft" />
                  </label>
                  <label className="unit-label">
                     m&#178;
                     <input type="radio" name="radio-unit" checked={unit==="mm"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-mm" value="mm" />
                  </label>
               </div>
         </div>
      )
   }
   const CustomTextInput = ({ label, ...props }) => {
      const [field, meta] = useField(props)
      return (
         <div className="row form-group p-1">
               <div className="col-xs-12 col-sm-4">
                  <label htmlFor={props.id || props.name}>{label}</label>
               </div>
               <div className="col-xs-12 col-sm-4">
                  <input className="text-input" {...field} {...props} />
                  { meta.touched && meta.error ? (
                     <div className="error">{ meta.error }</div>
                  ) : null }
               </div>
         </div>
      )
   }
   const CustomSelect = ({ label, modalFor, ...props }) => {
      const [field, meta] = useField(props, 'checkbox')
      return (
         <div className="row form-group p-1">
               <div className="col-xs-12 col-sm-4">
                  <label htmlFor={props.id || props.name}>{label}</label>
               </div>
               <div className="col-xs-12 col-sm-4">
                  <select {...field} {...props} id={props.name} />
                  { meta.touched && meta.error ? (
                     <div className="error">{ meta.error }</div>
                  ) : null }
               </div>
         </div>
      )
   }

   const firstUpdate = useRef(true)

   useLayoutEffect(() => {
      if (firstUpdate.current) {
         firstUpdate.current = false
         return
      }

      // Update the current step.
      setCurrentStep({ step: "groutQuoteCreated" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Provide Coverage Details")
      setStepsCompleted(stepsCompleted)
      // Set the appHeader for Step state.
      setAppHeader("Quote created.")
   }, [coverageData])

    const groutCalculation = (jointSize, tileHeight, tileThickness, tileWidth, totalArea) => {

        const apiUrlRoot = config.groutEndpoint
        const [tileThicknessText, tileThicknessCoverage] = tileThickness.split('|');
        const [jointSizeText, jointSizeCoverage] = jointSize.split('|');

        let url = `${apiUrlRoot}/GetGroutResult/${unit}/${totalArea}/${productCoverage}/${tileWidth}/${tileHeight}/${tileThicknessCoverage}/${jointSizeCoverage}`
   console.log(url)
      axios.get(url)
          .then(res => {
              setCoverageData({ coverage: res.data.groutCoverage, quantity: res.data.quantity, unitsRequiredDefault: res.data.unitsRequiredDefault, actualUnitsRequiredDefault: res.data.actualUnitsRequiredDefault, tileThicknessText: tileThicknessText, jointSizeText: jointSizeText })
      })
      .catch(err => {
         console.log(err)
      })
   }

    const handleFormSubmission = (formData) => {
      const { jointSize, tileHeight, tileThickness, tileWidth, totalArea } = formData
      // Add the input data to state of App.
      setCoverageDetails({ formData })

      // Calculate grout amount required.
      groutCalculation(jointSize, tileHeight, tileThickness, tileWidth, totalArea)
   }

   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
               <h3>Provide Coverage Details</h3>
               <Formik
                  initialValues={{
                     totalArea: '',
                     unit: 'sqft',
                     tileWidth: '',
                     tileHeight: '',
                     tileThickness: '',
                     jointSize: ''
                  }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validationSchema={Yup.object().shape({
                     totalArea: Yup.number()
                           .required('This field is required.')
                           .positive('This value must be positive.'),
                     unit: Yup.string()
                           .required('Select ft&#178; or m&#178;')
                  })}
                  onSubmit={ (values) => {
                     handleFormSubmission(values)
                  } }
                  >
                     { // Render props
                     props => (
                           <Form>
                              <CustomInputTotalArea label="Total Area" name="totalArea" type="number" placeholder="Total area" />
                              <CustomTextInput label="Tile Width" name="tileWidth" type="number" placeholder="Width" />
                             <CustomTextInput label="Tile Length" name="tileHeight" type="number" placeholder="Length" />
                              <CustomSelect label="Tile Thickness" name="tileThickness">
                                 <option value=""></option>
                                 {
                                       tileThicknesses.map(t => {
                                           return (
                                              (unit === "sqft") ?
                                                   <option key={t.standardName} value={`${t.standardName}|${t.standardValue}`}>{t.standardName}</option>
                                                   : <option key={t.metricName} value={`${t.metricName}|${t.standardValue}`}>{t.metricName}</option>
                                          )
                                       })
                                 }
                              </CustomSelect>
                              <CustomSelect label="Joint Size" name="jointSize">
                                 <option value=""></option>
                                 {
                                       jointSizes.map(j => {
                                           return (
                                               (unit === "sqft") ?
                                                   <option key={j.standardName} value={`${j.standardName}|${j.standardValue}`}>{j.standardName}</option>
                                                   : <option key={j.metricName} value={`${j.metricName}|${j.standardValue}`}>{j.metricName}</option>
                                          )
                                       })
                                 }
                              </CustomSelect>
                              <button className="btn btn-primary" type="submit">{ props.isSubmitting ? 'Loading...' : 'CALCULATE' }</button>
                           </Form>
                     )}
               </Formik>
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/grout/GroutCoverageDetails.js